import { Injectable } from "@angular/core";
import { ApmService } from "@elastic/apm-rum-angular";
import { EnvironmentService } from "./environment.service";

@Injectable({
    providedIn: 'root',
})
export class ApmServiceHandler {
    constructor(private readonly environmentService: EnvironmentService, private readonly apmService: ApmService) { }

    init() {
        if (!this.environmentService.get('apmIsEnabled')) {
            return;
        }
        this.apmService.init({
            serviceVersion: this.environmentService.get('apmServiceVersion') as string,
            active: this.environmentService.get('apmIsEnabled') as boolean,
            instrument: this.environmentService.get('apmGettingMetrics') as boolean,
            serviceName: this.environmentService.get('apmServiceName') as string,
            serverUrl: this.environmentService.get('apmServerUrl') as string,
            environment:this. environmentService.get('apmEnvironment') as string,
            logLevel: this.environmentService.get('apmLogLevel') as LogLevel,
            breakdownMetrics: this.environmentService.get('apmBreakdownMetrics') as boolean,
        });
    }
}
